import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-categories-main",
    templateUrl: "./categories.main.component.html"
})
export class CategoriesMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
